function initCssVariables() {
  const $announcementBanner = $('.header-announcement-banner');
  let announcementBannerShowingHeight = 0;
  const headerHeight = Math.floor($('.site-header').outerHeight());

  if ($announcementBanner.length) {
    announcementBannerHeight = Math.floor($('.header-announcement-banner').outerHeight());
    announcementBannerScolledY = Math.abs($announcementBanner[0].getBoundingClientRect().y);
    if (announcementBannerHeight >= announcementBannerScolledY) {
      announcementBannerShowingHeight = announcementBannerHeight - announcementBannerScolledY;
    }
  }
  document.documentElement.style.setProperty('--announcement-header-height', `${announcementBannerShowingHeight}px`);
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
}

function initNavigation() {
  // NAVIGATION //

  var $nav = $('.js-nav');
  var $navToggle = $('.js-navToggleBtn'); // this opens the nav < xlarge
  var $subNavButton = $('.js-subnavToggleBtn'); // this is for touching
  var $subNavToggle = $subNavButton.parent('li'); // this is for hovering
  var $subNavBgToggle = $subNavButton.parent('.js-hasDropdown'); // this is for hovering
  var $subNavBgToggle2 = $('.site-nav'); // this is for hovering
  var $buttonLink = $('.js-link'); // When a button is clickable as link

  var $submenuToggle = $('.js-submenuBtn');
  var $submenu = $('.dropdown-wrap');
  var $submenuBackBtn = $('.js-submenuBackBtn');

  var $thirdmenuToggle = $('.js-thirdmenuBtn');
  var $thirdmenu = $('.js-thirdmenu');
  var $submenuBackBtn = $('.js-submenuBackBtn');

  
  var $stickySearchToggle = $('[data-js-sticky-search-toggle]');
  var $stickySearchClose = $('[data-js-sticky-search-close]');
  
  $submenuBackBtn.on('click', closeSubMenu);
  $thirdmenuToggle.on('click', toggleThirdMenu);

  $navToggle.on('click', toggleNav);
  $subNavButton.on('click', openSubNav);
  $submenuToggle.on('click', openSubMenu);
  $subNavToggle.hoverIntent({ over: dropDown, timeout: 200 });
  $subNavBgToggle2.hoverIntent({ over: dropBg, timeout: 200 });
  $buttonLink.on('click', buttonLink);

  $stickySearchToggle.on('click', handleStickySearchClick);
  $stickySearchClose.on('click', hideStickySearchForm);

  $(document).on('click', '.header__search-form-clear', function () {
    $('[name="q"]').val('');
    $('[name="q"]').focus();
    $(this).css('visibility', 'hidden');
  })

  function hideStickySearchForm() {
    $('body').removeClass('show-sticky-search-form');
  }

  function handleStickySearchClick() {
    if ($('body').hasClass('show-sticky-search-form')) {
      $('body').removeClass('show-sticky-search-form');
    } else {
      $('body').addClass('show-sticky-search-form');
    }
  }

  function toggleThirdMenu(event) {
    event.preventDefault();

    $(this).toggleClass('is-active').next($thirdmenu)
      .toggleClass('is-active');
  }

  function openSubMenu(event) {
    if (window.innerWidth < 1025) {
      event.preventDefault();

      $(this).next($submenu).addClass('is-active');
    }
  }

  function closeSubMenu(event) {
    if (window.innerWidth < 1025) {
      event.preventDefault();

      $(this).parent($submenu).removeClass('is-open');
      $('.dropdown').removeClass('is-open');
      // $('.dropdown').hide();
      $('.js-subnavToggleBtn').removeClass('is-open');
    }
  }

  function dropDown() {
    if (window.innerWidth >= 1025) {
      $(this)
        .children('button')
        .first()
        .toggleClass('is-open')
        .next('.dropdown-wrap')
        .toggleClass('is-open');
    }
  }

  function dropBg() {
    if (site.browserWidth >= 1025) {
      if (event.target.classList.contains('site-nav__link--btn') && event.target.classList.contains('no-child')) {
        $(this).removeClass('is-open');
      } else {
        $(this).toggleClass('is-open');
      }
    }
  }

  function openSubNav(event) {
    event.preventDefault();

    function Drop() {
      $(this)
        .children('button')
        .first()
        .toggleClass('is-open')
        .next('.dropdown-wrap')
        .toggleClass('is-open');
    }

    if (window.innerWidth < 1025 && event.type == 'click') {
      $(this)
        .toggleClass('is-open')
        .next('.dropdown-wrap')
        // .slideToggle()
        .toggleClass('is-open');
    } else if (window.innerWidth >= 1025 && (event.type == 'mouseenter' || event.type == 'mouseleave')) {
      // You are large, and you hovered
      // Not using this now, instead using hover intent and dropDown

    } else {
      // Die for all other events
      return false;
    }
  }

  function toggleNav(event) {
    event.preventDefault();

    $nav.toggleClass('active');
    $('body').toggleClass('nav-active');
    $navToggle.toggleClass('is-active');
  }

  function buttonLink(event) {
    event.preventDefault();

    if (window.innerWidth >= 1025) {
      window.location = $(this).data('href');
    }
  }
}

function initNavStick() {
  const offset = -115;
  if ($('.site-header')[0].getBoundingClientRect().y > offset) {
    $('body').removeClass('sticky-nav-enabled');
  } else {
    $('body').addClass('sticky-nav-enabled');
  }
}

function initFormValidate() {
  $('.js-newsletterFormContainer form').validate({
    rules: {
      'contact[email]': {
        required: true,
        email: true,
      },
    },
    messages: {
      'contact[email]': {
        required: 'Please enter your email address.',
        email: 'Please enter a valid email address.',
      },
    },
    errorPlacement(error, element) {
      error.insertBefore('.input-group');
    },
  });

  $('.js-contactForm form#contact_form').validate({
    rules: {
      'contact[name]': {
        required: true,
      },
      'contact[email]': {
        required: true,
        email: true,
      },
      'contact[body]': {
        required: true,
      },
    },
    messages: {
      'contact[name]': {
        required: 'Please enter your name.',
      },
      'contact[email]': {
        required: 'Please enter your email address.',
        email: 'Please enter a valid email address.',
      },
      'contact[body]': {
        required: 'Please provide a brief message.',
      },
    },
  });
  $('#CustomerLoginForm form#customer_login, form#create_customer, form#activate_customer_password').validate({
    rules: {
      'customer[email]': {
        required: true,
        email: true,
      },
      'customer[password]': {
        required: true,
      },
    },
    messages: {
      'customer[email]': {
        required: 'Please enter your email address.',
        email: 'Please enter a valid email address.',
      },
      'customer[password]': {
        required: 'Please enter password.',
      },
    },
  });
  $('#RecoverPasswordForm form').validate({
    rules: {
      email: {
        required: true,
        email: true,
      },
    },
    messages: {
      email: {
        required: 'Please enter your email address.',
        email: 'Please enter a valid email address.',
      },
    },
  });
}

function initBackTop() {
  $('.js-backToTop').click(() => {
    $('html, body').animate({
      scrollTop: 0,
    }, 1000);
  });
}

function initToggleContent() {
  $('.js-toggleBtn').on('click', function (e) {
    $(this).next('.js-toggleContent').slideToggle();
    $(this).toggleClass('is-open');
  });
}

const LazyLoad = {

  /**
   * Set the background image as a media query on an element
   *
   * @param: {Node} tile: the element to add the CSS background image srcset to
   */
  setTileMediaQueries: (tile) => {
    const tileIdentifier = tile.getAttribute('data-io-id');
    const tileImagesRaw = tile.getAttribute('io-bg-srcset');
    const tileImages = tileImagesRaw.split(',');
    const stylesElement = document.createElement('style');
    tileImages.forEach((tileImage) => {
      const imageParts = tileImage.trim().split(' ');
      stylesElement.innerHTML += `@media screen and (min-width: ${imageParts[1]}) {
        [data-io-id="${tileIdentifier}"] {
          background-image: url('${imageParts[0]}');
        }
      }`;
    });
    document.body.appendChild(stylesElement);
  },

  /**
   * Default callback for the lazyloader. Will load in image sources and then unobserve the element
   *
   * @param: {Node} tile: the element just loaded into the viewport
   * @param: {Object} observer: the observer that is watching/notifiying the tile element
   * @param: {boolean} isIntersecting: whether the tile is in the viewport or if it just left the viewport
   */
  setTileBackground: (tile, observer, isIntersecting) => {
    console.log("will set the tile attributesssssssss from custom sections collection", tile);

    // only set img sources if the tile is in the viewport
    if (!isIntersecting) {
      return;
    }
    // check if the element has a CSS background to be set
    if (tile.hasAttribute('io-bg-src')) {
      const backgroundURL = tile.getAttribute('io-bg-src');
      tile.style.backgroundImage = `url('${backgroundURL}')`;
    }
    // check if there is a sourceset for setting backgrounds via CSS
    if (tile.hasAttribute('io-bg-srcset')) {
      LazyLoad.setTileMediaQueries(tile);
    }
    // check if there is a src to set on an image tag
    if (tile.hasAttribute('io-img-src')) {
      const src = tile.getAttribute('io-img-src');
      tile.setAttribute('src', src);
      // also check if the img tag has a srcset attribute to set
      if (tile.hasAttribute('io-img-srcset')) {
        const srcset = tile.getAttribute('io-img-srcset');
        tile.setAttribute('srcset', srcset);
      }
    }
    // unobserve the tile
    if (observer) {
      observer.unobserve(tile);
    }
    // need to notify of the image loading in
    const imageEvent = new CustomEvent('ioSourceSet', {
      detail: { target: tile },
    });
    document.dispatchEvent(imageEvent);
  },

  /**
   * Binds an observer to given elements if IOs exist in the browser
   *
   * @param: {NodeList} toObserve: list of elements that will be observed by the single observer
   * @param: {Function} successCallback: the callback for when an element is lazyloaded / enters/exits the viewport
   * @param: {Function} errorCallback: callback called on a per element basis if the browser doesn't support intersection observers
   * @param: {String} margins: string with the margins for when an element counts as being in the viewport
   */
  createObservers: ({ toObserve, successCallback, errorCallback, margins }) => {
    // check if IOs are available or not
    if ('IntersectionObserver' in window) {
      // define everything we need to pass to the callback
      const rootMargin = { rootMargin: margins };
      const callback = (entries, observer) => {
        entries.forEach((entry) => {
          successCallback(entry.target, observer, entry.isIntersecting);
        });
      };
      // our actual observer
      const observer = new IntersectionObserver(callback, rootMargin);
      // have to bind to each individual tile
      toObserve.forEach((tile) => {
        observer.observe(tile);
      });
    } else {
      // If there is an error callback defined, use it. Otherwise, fallback to default success callback
      const callback = errorCallback !== false ? errorCallback : successCallback;
      toObserve.forEach((tile) => {
        callback(tile, false, true);
      });
    }
  },

  /**
   * Setup observers for a group of elements on the page
   *
   * @param: {String} queryString: a query query for grabbing all elements to observe
   * @param: {Function} callback: the callback function for when the elements enter/exit the view
   * @param: {Function} errorCallback: the callback function for if Intersection Observers are not available in the current browser.
   * @param: {String} margins: string representing the bounds for when the tiles load
   */
  setupObservers: ({ queryString = '[io-img-src], [io-img-srcset], [io-bg-src], [io-bg-srcset]', callback = LazyLoad.setTileBackground, errorCallback = false, margins = '0% 0% 0% 0%' } = {}) => {
    const toObserve = document.querySelectorAll(queryString);
    LazyLoad.createObservers({
      toObserve,
      successCallback: callback,
      errorCallback,
      margins,
    });
  },
};

$(document).on('ready', () => {
  // Open & Close Minicart here

  initCssVariables();

  initFormValidate();
  
  initBackTop();

  initToggleContent();

  initNavigation();

  initNavStick();

  LazyLoad.setupObservers();
})

window.addEventListener('resize', () => {
  initCssVariables();
})

$(window).scroll((evt) => {
  initCssVariables();
  initNavStick();
});
